// removed by extract-text-webpack-plugin
module.exports = {"container":"_2QVqqtYFJDLB-P7Btut1R9","imageBanner":"_2FVeLRRrnIivHQFCxFUiok"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/promoCarousel.css
// module id = 954
// module chunks = 0